module.exports = __webpack_public_path__ + "img/logo.6d764d30.png";